const faqs = [
  {
    q: '在线吃瓜最新入口地址是什么？',
    a: '在线吃瓜的最新入口地址会实时更新在本站首屏及"最新快讯"模块中。您可以将本站加入收藏夹，每次打开即可获取当前有效的91在线吃瓜网、线路一及其他备用网址的最新入口信息，确保访问不迷路。',
  },
  {
    q: '为什么有时候在线吃瓜入口打不开？',
    a: '入口无法访问通常是由于DNS污染、运营商屏蔽或服务器临时维护所致。在线吃瓜提供多条备用网址和官方线路，当主入口异常时，请尝试切换到其他备用通道。本站"入口热度榜"模块会实时显示各线路的可用状态。',
  },
  {
    q: '如何确保访问的是真正的在线吃瓜官方入口？',
    a: '请务必通过本站提供的入口地址进行访问。在线吃瓜官方线路和备用网址均经过安全认证检测，我们定期验证每个入口的真实性与安全性。切勿通过搜索引擎或不明来源的链接访问，以防进入钓鱼网站。',
  },
  {
    q: '在线吃瓜有移动端APP吗？',
    a: '在线吃瓜目前以网页形式提供服务，无需下载任何APP。网站已针对手机浏览器进行全面适配优化，移动端访问体验流畅、流量消耗低。请通过本站提供的移动端专属入口进行访问，即可获得最佳体验。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-8 h-8 rounded-lg bg-accent-500/15 flex items-center justify-center flex-shrink-0">
            <i className="ri-question-line text-accent-400"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-100">常见问题</h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          {faqs.map((faq, i) => (
            <div key={i} className="p-5 rounded-xl bg-background-100 border border-background-300/30">
              <h3 className="text-sm md:text-base font-semibold text-foreground-200 mb-2 flex items-start gap-2">
                <span className="text-primary-400 flex-shrink-0 mt-0.5">Q:</span>
                {faq.q}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed flex items-start gap-2">
                <span className="text-accent-400 flex-shrink-0 mt-0.5">A:</span>
                {faq.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}